<template>
  <div style="width: 100%;">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="120px" >
          <el-row>
            <el-col :span="9">
              <el-form-item :label="$t('field.complaintDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row>          
          </el-row>   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <Table ref="table1" :tableData="tableData" :linkAction="linkAction" @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindRmaHandlingByCondition } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";

  
export default {
  name: 'rmaHandling',
  data() {    
    return {       
      sdate: '',
      edate: '',
      sortColumn:'',
      sortType:'',
      tableData: {
        columns: [
          { field: "requestNo", title: this.$i18n.t('field.docNo'), width: 160, link:true, align:'center', width:180 },         
          { field:"status", title:  this.$i18n.t('field.status'), width:100  }, 
          { field:"customer", title:  this.$i18n.t('field.customerNo'), width:150  }, 
          { field:"complaintDate", title:  this.$i18n.t('field.complaintDate'), width:160  }, 
          { field:"rmaNumber", title:  'RMA Number', width:150  }, 
          { field:"model", title:  'Model', width:100  }, 
          { field:"serialNo", title:  'Serial No', width:150  },
          { field:"symptom", title:  this.$i18n.t('field.symptom'), width:200  }, 
          { field:"incxFae", title: 'INCX FAE', width:150  }, 
          { field:"panelReceivedDate", title:  this.$i18n.t('field.panelReceivedDate'), width:180  }, 
          { field:"vrifiedDate", title:  this.$i18n.t('field.vrifiedDate'), width:150  }, 
          { field:"reportUploadDate", title:  'Report Upload Date', width:200  }, 
          { field:"failureStage", title:  'Failure stage', width:200  }, 
          { field:"judgmentLiability", title:  this.$i18n.t('field.judgmentofLiability'), width:200  }, 
          { field:"shippingDate", title:  this.$i18n.t('field.shippingDate'), width:150  }, 
          { field:"faeProposalDay", title:  this.$i18n.t('field.faeProposalDay'), width:180  }, 
          { field:"complainDateShippingDateDiff", title:  this.$i18n.t('field.custComplaintDateShippingDate'), width:320  }, 
          { field:"panelID", title:  'Panel Id', width:140  }, 
          { field:"modelName", title:  'Model Name', width:140  }, 
          { field:"productID", title:  'ProductID', width:140  }, 
          { field:"remark", title: 'Remark', width:200  },
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.customerFeedbackHandling')
      },    
     
    };
  }, 
  components: {
    Breadcrumb,
    Table
  },
  mounted() {  
    this.findData() 

  },

  methods: {
    findData(){      
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
       if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }
      
      apiFindRmaHandlingByCondition({ headers: authHeader(), sdate : sdate, edate : edate, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
          this.tableData.data = response.data;  
          this.tableData.originalTableData =  this.tableData.data;  
          this.$refs.table1.$refs.filterTable.doLayout();
      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },   
    linkAction(row, index){    
      //this.$router.push("/ProcessFeedback/" + row.feedbackId);
      const { href } = this.$router.resolve("/ProcessFeedback/" + row.feedbackId );
      window.open(href, '_blank');
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      debugger
      this.findData()
    }     
  }
};
</script>
